import React from "react";

const blogs = [
  {
    image: require("./../../images/blog/event_2.jpg"),
    title: "COMMUNIQUE Projet Vallée Val d’OR II",
    date: "31",
    month: "DEC",
    year: "2020",
  },
  {
    image: require("./../../images/annonces/image1.jpg"),
    title: "COMMUNIQUE Projet Vallée Val d’OR I",
    date: "25",
    month: "SEP",
    year: "2022",
  },
];

var bgimg1 = require("./../../images/background/cross-line2.png");

class Blog1 extends React.Component {
  render() {
    return (
      <>
        <div
          className={`${this.props.bgcolor} section-full mobile-page-padding p-t20 p-b80 mobile-page-padding`}
          style={{ backgroundColor: "#045384" }}
        >
          <div className="container">
            {/* TITLE START */}
            <div  data-aos-duration="800"  data-aos="fade-up" className="section-head">
              <div className="sx-separator-outer separator-center">
                <div
                  className="sx-separator bg-moving bg-repeat-x"
                  // style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                >
                  <h3 className="sep-line-one text-white">Actualités</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            {/* IMAGE CAROUSEL START */}
            <div className="section-content">
              <div className="row justify-content-center">
                {blogs.map((item, index) => (
                  <div data-aos-duration="800"  data-aos="zoom-in-down" className="col-lg-6 col-md-6 col-sm-12" key={index}>
                    <div className="blog-post blog-grid date-style-2">
                      <div className="sx-post-media sx-img-effect img-reflection">
                        <a href={"/annonces/valle-val-or-1"}>
                          <img src={item.image} alt="" />
                        </a>
                      </div>
                      <div className="sx-post-info p-t10">
                        <div className="sx-post-meta ">
                          <ul>
                            <li className="post-date ">
                              <strong>{item.date}</strong>{" "}
                              <span>{item.month}</span> <span>{item.year}</span>{" "}
                            </li>
                            <li className="post-author">
                              <a href={"/annonces/valle-val-or-1"}>
                                {" "}
                                <span className="text-white">
                                  {item.date} {item.month} {item.year}
                                </span>
                              </a>{" "}
                            </li>
                            {/* <li className="post-comment"> <a href={"/annonces/valle-val-or-1"}>{item.comments}</a> </li> */}
                          </ul>
                        </div>
                        <div className="sx-post-title ">
                          <h4 className="post-title">
                            <a
                              href={"/annonces/valle-val-or-1"}
                              className="text-white"
                            >
                              {item.title}
                            </a>
                          </h4>
                          <p className="text-white">
                            Dans le cadre du renforcement de ses actions de
                            communication, le bureau de l’Association la vallée
                            a le plaisir d’informer ses adhérents et membres
                            bénéficiaires du programme...
                          </p>
                        </div>
                        <div className="sx-post-readmore">
                          <a
                            href={"/annonces/valle-val-or-1"}
                            title="Voir Plus"
                            rel="bookmark"
                            className="site-button-link text-white"
                          >
                            Voir Plus
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="hilite-title text-left p-l50 text-uppercase">
            <strong style={{ color: "rgb(158 158 158 / 21%)", top: '15%' }}>
              Actualités
            </strong>
          </div>
        </div>
      </>
    );
  }
}

export default Blog1;
